import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {EntitiesRecognizerResponseApiModel} from "./entities-recognizer.response-api-model";
import {ENTITY_TYPES} from "../../../core/app/consts";

export class EntitiesRecognizerDataSource extends BaseDomainModel {
  apiModel: EntitiesRecognizerResponseApiModel;

  get athletes(): Array<Number> {
    return this.apiModel?.Athletes;
  }

  get competitions(): Array<Number> {
    return this.apiModel?.Competitions;
  }

  get competitors(): Array<Number> {
    return this.apiModel?.Competitors;
  }

  get games(): Array<Number> {
    return this.apiModel?.Games;
  }

  get entityType(): ENTITY_TYPES {
    let entityType: ENTITY_TYPES = null;

    if (this.competitions?.length > 0) {
      entityType = ENTITY_TYPES.competition;
    } else if (this.competitors?.length > 0) {
      entityType = ENTITY_TYPES.team;
    }

    return entityType;
  }

  get entityId(): Number {
    let entityId: Number = null;

    if (this.competitions?.length > 0) {
      entityId = this.competitions[0];
    } else if (this.competitors?.length > 0) {
      entityId = this.competitors[0];
    }

    return entityId;
  }
}
